import { render, staticRenderFns } from "./templateAgeGroup.vue?vue&type=template&id=75156300&scoped=true"
import script from "./templateAgeGroup.vue?vue&type=script&lang=js"
export * from "./templateAgeGroup.vue?vue&type=script&lang=js"
import style0 from "./templateAgeGroup.vue?vue&type=style&index=0&id=75156300&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75156300",
  null
  
)

export default component.exports